import PersonalizerApi from "@/services/personalizer_api";
import {
  RETRIEVE_GPT_CONVERSATIONS,
  RETRIEVE_GPT_CONVERSATION_DETAIL,
} from "@/store/_actiontypes";
import { SET_GPT_CONVERSATIONS } from "@/store/_mutationtypes";
import { GptConversationMapper } from "@/helpers/dataMappers/gptConversations";
import { updateLoaderTo } from "./account";
import { ENDPOINT_TYPES, ENDPOINT_PATHS } from "@/global/_constants";

const state = {
  gpt_conversations: { total: 0, conversations: [] },
};

const actions = {
  [RETRIEVE_GPT_CONVERSATIONS](
    { commit, state },
    {
      project_id,
      start_date,
      end_date,
      start = 0,
      size = 100,
      query,
      userId,
      feedback,
      endpoint,
      messageSeen = null,
      archiveFilter = null,
      sort_by = {},
      search_text,
      gpt_profile_id = null,
    },
  ) {
    updateLoaderTo(true);

    const sort = sort_by;

    const queryBuilder = {};
    queryBuilder.searches = {};
    queryBuilder.filters = { request_body: {} };
    if (query !== "" && query !== null) {
      queryBuilder.searches.query = query;
    }
    if (endpoint !== "" && endpoint !== null) {
      if (endpoint === ENDPOINT_TYPES.ASK) queryBuilder.filters.request_url = ENDPOINT_PATHS.ASK;
      if (endpoint === ENDPOINT_TYPES.VISION) queryBuilder.filters.request_url = ENDPOINT_PATHS.VISION;
      if (endpoint === ENDPOINT_TYPES.REALTIME) queryBuilder.filters.request_url = ENDPOINT_PATHS.REALTIME;
      if (endpoint === ENDPOINT_TYPES.QUESTIONNAIRE) queryBuilder.filters.request_url = ENDPOINT_PATHS.QUESTIONNAIRE;
    }
    if (userId !== "" && userId !== null) {
      queryBuilder.filters.request_body.user_id = userId;
    }
    if (feedback) {
      queryBuilder.filters.feedback = {
        type: feedback,
      };
    }
    if (messageSeen !== null) {
      queryBuilder.filters.message_seen = messageSeen;
    }
    if( gpt_profile_id !== null && gpt_profile_id !== "") {
      queryBuilder.filters.request_body.gpt_profile_id = gpt_profile_id;
    }

    const payload = {
      start_date,
      end_date,
      start,
      size,
      query: queryBuilder,
      sort,
      search_text,
    };
    if (archiveFilter !== null && archiveFilter !== undefined) {
      payload.is_archived = archiveFilter;
    }
    
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(
        `gpt/conversations`,
        payload,
        {
          headers: {
            "project-id": project_id,
          },
        },
      ).then(
        response => {
          const conversations =
            response.data.detail?.response?.conversations
              .filter(conversation => conversation !== null)
              .map(conversation => {
                return GptConversationMapper.mapBackendToFrontend(conversation);
            });
          commit(SET_GPT_CONVERSATIONS, {
            total: response.data.detail?.response?.matched_conversation,
            conversations: conversations,
          });
          updateLoaderTo(false);
          resolve(response);
        },
        error => {
          reject(error);
          updateLoaderTo(false);
        },
      );
    });
  },
  [RETRIEVE_GPT_CONVERSATION_DETAIL](
    { commit, state },
    {
      conversation_id,
      auth_token = null,
      project_id = null,
      project_key = null,
      api_key = null,
      client_key = null,
    },
  ) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/conversations/${conversation_id}`, {
        headers: {
          "auth-token": auth_token,
          "project-id": project_id,
          "project-key": project_key,
          "api-key": api_key,
          "client-key": client_key,
        },
      }).then(
        response => {
          const conversation = GptConversationMapper.mapBackendToFrontend(
            response.data.detail.response,
          );
          resolve(conversation);
          updateLoaderTo(false);
        },
        error => {
          reject(error);
          updateLoaderTo(false);
        },
      ).catch((error) => {
        reject(error);
        updateLoaderTo(false);
      });
    });
  },
};

const mutations = {
  [SET_GPT_CONVERSATIONS](state, data) {
    state.gpt_conversations = data;
  },
};

export const gpt = {
  namespaced: true,
  state,
  actions,
  mutations,
};
